module.exports = __webpack_public_path__ + "static/media/horse-race.ab600ea0.webp";